import { FelaCSS, FelaCSSWithCustomSelectors } from '../../components/fela/flowtypes';
import { colors } from '../../themes/variables';

interface UploadingStyleTypes {
  uploading: FelaCSS;
  fileUploadingWrap: FelaCSS;
  fileUploadErrorCol: FelaCSS;
  fileUploadingCol: FelaCSSWithCustomSelectors;
  fileUploadingImageWrap: FelaCSS;
  fileUploadingImage: FelaCSS;
  fileUploadErrorWrap: FelaCSS;
  fileUploadError: FelaCSSWithCustomSelectors;
  progress: FelaCSSWithCustomSelectors;
}

export const styles: UploadingStyleTypes = {
  uploading: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  fileUploadingWrap: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginTop: '20px',
    width: '100%',
  },

  fileUploadErrorCol: {
    width: '100%',
    paddingLeft: '10px',
    paddingRight: '10px',
  },

  fileUploadingCol: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '10px',
    marginRight: '10px',

    '> div': {
      width: '100%',
    },
  },

  fileUploadingImageWrap: {
    margin: '10px 0',
    position: 'relative',
    paddingBottom: '67%',
    width: '100%',
    overflow: 'hidden',
    display: 'block',
  },

  fileUploadingImage: {
    display: 'block',
    flexDirection: 'unset',
    position: 'absolute',
    left: '0',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%',
  },

  fileUploadErrorWrap: {
    position: 'relative',
    margin: '10px 0',
    width: '100%',
    border: `1px dashed ${colors.space40} !important`,
    wordWrap: 'break-word',
  },

  fileUploadError: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '15px',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    color: colors.space40,
    fontDefault: 16,

    '> strong': {
      color: colors.blushTangerine120,
    },
  },
  progress: {
    width: '100%',
    height: '10px',
    borderRadius: '10px',
    backgroundColor: colors.space15,
    '::-webkit-progress-value': {
      backgroundColor: colors.indigoCrush,
      borderRadius: '10px',
    },
    '::-webkit-progress-bar': {
      backgroundColor: colors.space15,
      borderRadius: '10px',
    },
    '::-moz-progress-bar': {
      backgroundColor: colors.indigoCrush,
      borderRadius: '10px',
    },
  },
};
